import UtilsUrl from "../../utils/UtilsUrl";
import api from "../api";

class ConfigEmailService {
  addconfigurationEmailBySociete(idUser, emails, typeConfigEmails) {
    return api.put(
      UtilsUrl.ConfigEmailPosURL() +
        "/addconfigurationEmailBySociete/" +
        idUser +
        "/" +
        emails +
        "?typeConfigEmails=" +
        typeConfigEmails
    );
  }
  getconfigurationEmailBySociete(idUser) {
    return api.get(
      UtilsUrl.ConfigEmailPosURL() + "/getconfigurationEmailBySociete/" + idUser
    );
  }
  removeEmailBySociete(idUser, email, typeConfigEmails) {
    return api.put(
      UtilsUrl.ConfigEmailPosURL() +
        "/removeEmailBySociete/" +
        idUser +
        "/" +
        email +
        "?typeConfigEmails=" +
        typeConfigEmails
    );
  }
}
export default new ConfigEmailService();
